import { selectFromServiceAccountDto } from '../../models';

export default selectFromServiceAccountDto()
  .uuid
  .fullname
  .createdOn
  .expiresOn
  .createdByUser(u => u.fullname)
  .toString();
